/**
 * Added to Cart Drawer - extends generic DrawerComponent
 * Shows a confirmation when a product is added to cart, distinct from the full cart drawer.
 */
class AddedToCartDrawer extends DrawerComponent {
  constructor() {
    super();
  }

  /**
   * Render the added product and open the drawer
   * @param {Object} parsedState - Cart API response with sections
   */
  renderContents(parsedState) {
    // Update cart icon bubble with new count
    this.updateCartIconBubble(parsedState);

    // Render the added product from section HTML
    this.renderAddedProduct(parsedState);

    // Open the drawer
    setTimeout(() => {
      this.querySelector('.drawer__overlay')?.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  /**
   * Update the cart icon bubble to show new item count
   */
  updateCartIconBubble(parsedState) {
    const cartIconBubbleHtml = parsedState.sections?.['cart-icon-bubble'];
    if (cartIconBubbleHtml) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = this.getSectionInnerHTML(cartIconBubbleHtml);
      }
    }
  }

  /**
   * Render the added product in the drawer using the section HTML
   * The section renders ALL cart items (hidden). We show only the one matching the added variant ID.
   */
  renderAddedProduct(parsedState) {
    const productContainer = this.querySelector('#AddedToCartDrawer-Product');
    if (!productContainer) return;

    // Get the rendered HTML from the section
    const sectionHtml = parsedState.sections?.['added-to-cart-drawer'];
    if (!sectionHtml) return;

    const content = this.getSectionInnerHTML(sectionHtml, '#AddedToCartDrawer-ProductContent');
    productContainer.innerHTML = content;

    // Find and show only the item matching the added variant ID
    const addedVariantId = parsedState.id;
    if (addedVariantId) {
      this.showAddedItem(productContainer, addedVariantId);
    } else {
      // Fallback: show the last item if no variant ID available
      const allItems = productContainer.querySelectorAll('.added-to-cart-drawer__item-container');
      if (allItems.length > 0) {
        allItems[allItems.length - 1].style.display = '';
      }
    }
  }

  /**
   * Show only the item matching the added variant ID
   */
  showAddedItem(container, variantId) {
    const allItems = container.querySelectorAll('.added-to-cart-drawer__item-container');

    // Find and show the matching item
    let found = false;
    allItems.forEach((item) => {
      if (item.dataset.variantId === String(variantId)) {
        item.style.display = '';
        found = true;
      }
    });

    // Fallback: if no match found, show the last item
    if (!found && allItems.length > 0) {
      allItems[allItems.length - 1].style.display = '';
    }
  }

  /**
   * Get inner HTML from a section response
   */
  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element?.innerHTML || '';
  }

  /**
   * Get sections to render for cart API request
   */
  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'added-to-cart-drawer',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('added-to-cart-drawer', AddedToCartDrawer);
